/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class superbillchargesreference extends IceEntity {
  superbill_charges_reference_key: string = "";
  superbill_charges_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
  return "SUPERBILL_CHARGES_REFERENCE";
  }
}
